module.exports = __webpack_public_path__ + "static/ic-bct-1e5a2f39bdbbb28fcd3a3a5a39573ef5.svg";